import { default as visualizationLabel } from './visualizationLabel'

const faqsDocumentations = {
  visualizationLabel,
}

export default faqsDocumentations
